export default {
  lang: {
    reset: 'Restablecer',
    search: 'Filtrar',
    expand: 'Expande',
    collapse: 'Abajo',
  },
};
